import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import LoginSplash from "../../components/auth/LoginSplash"
import LoginViaTT from "../../components/auth/LoginViaTT"
import { ENVIRONMENT } from "../../constants"

class SignInRequired extends Component {
  componentWillMount() {
    if (this.props.userDetails.client.subdomain) {
      const location = ENVIRONMENT.getTalentToolboxUrl(this.props.userDetails.client.subdomain)
      window.location = location
    }
  }
  render() {
    return this.props.userDetails.client.subdomain ? <LoginSplash /> : <LoginViaTT />
  }
}

function mapStateToProps(state) {
  return {
    userDetails: state.userDetail,
  }
}

SignInRequired.propTypes = {
  userDetails: PropTypes.shape({
    client: PropTypes.shape({
      subdomain: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

export default connect(mapStateToProps)(SignInRequired)



// WEBPACK FOOTER //
// ./src/routes/auth/SignInRequired.jsx